var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasswordshowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_57_2253)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.8427 6.25146C8.74359 6.25146 4.11948 9.04122 0.707357 13.5725C0.428928 13.9438 0.428928 14.4624 0.707357 14.8336C4.11948 19.3704 8.74359 22.1601 13.8427 22.1601C18.9417 22.1601 23.5658 19.3704 26.978 14.8391C27.2564 14.4679 27.2564 13.9492 26.978 13.578C23.5658 9.04122 18.9417 6.25146 13.8427 6.25146ZM14.2084 19.8071C10.8236 20.0201 8.02841 17.2303 8.24132 13.84C8.41602 11.0448 10.6817 8.77916 13.4769 8.60446C16.8617 8.39155 19.6569 11.1813 19.444 14.5716C19.2638 17.3613 16.9982 19.627 14.2084 19.8071ZM14.0392 17.2194C12.2158 17.334 10.709 15.8327 10.8291 14.0093C10.9219 12.5025 12.1448 11.285 13.6516 11.1868C15.475 11.0721 16.9818 12.5734 16.8617 14.3969C16.7634 15.9091 15.5405 17.1266 14.0392 17.2194Z",
    fill: "#DC6200"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_2253"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.6883,
    height: 26.6883,
    fill: "white",
    transform: "translate(0.498535 0.861816)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordshowIcon);
export default __webpack_public_path__ + "static/media/passwordshowIcon.95ed684abc04a04a0eca8cc9b48198ea.svg";
export { ForwardRef as ReactComponent };